import React, { ReactNode } from 'react';

import * as S from './HeaderNotificationButton.styles';

export enum HeaderNotificationTypeEnum {
  WARNING = 'warning',
  ERROR = 'error',
}

export interface HeaderNotificationButtonProps {
  type?: HeaderNotificationTypeEnum;
  className?: string;
  icon?: ReactNode;
  text?: ReactNode;
  handleClick?: () => void;
}

export const HeaderNotificationButton = ({
  type = HeaderNotificationTypeEnum.WARNING,
  className,
  icon,
  text,
  handleClick,
}: HeaderNotificationButtonProps) => {
  return (
    <S.NotificationButton
      data-testid="notification-button"
      withText={!!text}
      $type={type}
      className={className}
      role="button"
      onClick={handleClick}
    >
      <>
        {icon && (
          <S.IconWrapper data-testid="button-icon" withText={!!text}>
            {icon}
          </S.IconWrapper>
        )}
        {text && <S.ButtonText data-testid="button-text">{text}</S.ButtonText>}
      </>
    </S.NotificationButton>
  );
};
